import { render } from "./SettingFormToggle.vue?vue&type=template&id=037baa6a"
import script from "./SettingFormToggle.vue?vue&type=script&lang=js"
export * from "./SettingFormToggle.vue?vue&type=script&lang=js"

import "./SettingFormToggle.vue?vue&type=style&index=0&id=037baa6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__